document.addEventListener("DOMContentLoaded", function() {

    // Form validation
    // ===============
    const form = document.querySelector('[data-form-validate]');

    if (typeof Pristine === 'undefined' || !form)
        return;

    const validationConfig = {
        classTo: 'formInput',
        errorClass: 'has-error',
        successClass: 'is-valid',
        errorTextParent: 'formInput',
        errorTextTag: 'div',
        errorTextClass: 'errorMessage'
    }

    Pristine.addValidator("phone", function (phone) {
        let trimmedPhone = phone.replace('-', '').replace(' ', '').replace('+', '');
        return !isNaN(trimmedPhone);
    }, "Telefonní číslo není ve správném formátu.");

    Pristine.addMessages("cs", {
        required: "Toto pole je povinné.",
        email: "Toto pole neobsahuje validní e-mailovou adresu.",
        number: "Toto pole neobsahuje validní číslo.",
        integer: "Toto pole neobsahuje validní celé číslo.",
        url: "Toto pole neobsahuje validní URl adresu.",
        tel: "Toto pole neobsahuje validní telefonní číslo.",
        maxlength: "Text tohoto pole překročil délku ${1}.",
        minlength: "Text tohoto pole musí mít délku alespoň ${1}.",
        min: "Toto pole musí mít hodnotu alespoň ${1}.",
        max: "Toto pole může mít hodnotu nejvýše ${1}.",
        pattern: "Toto pole neobsahuje potřebný formát.",
        equals: "Tyto dvě pole se neshodují."
    });
    Pristine.setLocale("cs");
    let pristine = new Pristine(form, validationConfig);

    form.addEventListener('submit', (e) => {
        if(!pristine.validate()) {
            e.preventDefault();
        } else {
            let button=document.querySelector("[data-wait-for-response]");
            if (typeof button==="undefined"||button===null) {
                return
            }
            button.classList.add("waitForResponse");
        }

    });
});
const dataMaxSize = () => {
    const fileList = document.querySelectorAll("[data-max-size]");
    for (let i = 0; i < fileList.length; i++) {
        const form = fileList[i].closest("form");
        fileList[i].addEventListener('change', (ev) => {
            form.querySelector('[data-file-alert]')?.remove();
            const fileListArr = Array.from(fileList[i].files);
            let files = [];
            for (var x in fileListArr) {
                if (!(fileListArr[x].name != "item" && typeof fileListArr[x].name != "undefined" && fileListArr[x].size <= fileList[i].getAttribute('data-max-size'))) {
                    files.push(fileListArr[x]);
                    fileListArr.splice(x, 1);
                }
            }
            if (files.length > 0) {
                let alertFiles = '';
                files.forEach((val, i, array) => {
                    alertFiles = alertFiles + val.name;
                    if (i < (array.length - 1)) {
                        alertFiles = alertFiles + ', ';
                    }
                });
                form.innerHTML = '<div class="alert alert-danger" data-file-alert>Soubor ' + alertFiles + ' překročil maximální povolenou velikost a byl odebrán</div>' + form.innerHTML;
                dataMaxSize();
            }
        });
    }
}
document.addEventListener("DOMContentLoaded", () => {
    dataMaxSize();
})